<template>
 <!-- Modal -->
  <div class="content-box-gray card modal fade" id="tsdisplay-switcher-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content  ">
        <div class="modal-header title text-center">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title" id="myModalLabel" v-html="getHeading()" ></h4>
        </div>
        <div class=" content modal-body">
 <span v-html="message" class="bg-info"></span>
            <div class="list-group-item">
                            <div class="row">

                                <div v-for="aSlice in timeslicedata"  :key="aSlice.id" class="col-auto col-md-4">
                                    <div class="content-box-gray card" >
                                    <div class="title text-center d-flex">
                                        <h6 class="mt-2" style="margin:auto;" v-html="aSlice.headline"></h6>
                                     </div>
                               <div class="content">
                               <p class="mt-2 text-center" style="margin:auto;" ><i class="fas fa-clock fa-2xs"></i>{{getDateFormat(aSlice.created_at)}}</p>
                                <img v-if="aSlice.visual_option=='image'" class="float-left" style="width:50%;" :src="getFilePath(aSlice.image.file_path)"/>
                                <iframe  v-if="aSlice.visual_option=='video'" id="aSlice.id" :src="aSlice.videourl" width="50%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                                <div class="card mx-1 p-0">
                                    <div class="row d-flex justify-content-between">
                                        <p style="font-size:.5em !important;" class="m-2 px-2"  v-html="getSubset(aSlice.text, 80)"></p>
                                    </div>
                                </div>
                                <div class="d-flex flex-row justify-content-center">
                                    <div class="card bg-secondary mb-1 ">
                                        <table style="margin:auto;"><tr><td  style="text-align:center;font-size:.7em !important;" colspan="3">TimeSlice Visibility:</td></tr>
                                            <tr><td style="text-align:center;" v-for="item in visibilities" :key='item'>
                                                    <label class="radiolabel" :for="item"> {{item}}<br/>
                                                        <input @change="recordVisibilityChange(aSlice.id, item)" type="radio" :id="item" v-model="aSlice.visibility" :value="item" >
                                                    </label>
                                                </td>
                                                <td style="border:.5px solid #fff;">
                                                    <label class="savelabel" >Save<br/>
                                                        <i @click="saveVisiblityChange(aSlice.id)" title="Confirm &amp; Save" class="fas fa-save fai-white"></i>
                                                    </label>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from '../../../event-bus';
import Swal from 'sweetalert2';
import moment from 'moment';
import axios from 'axios';
export default {
    components:{

     },
    name: "ShowofForumVisibilitySwitcher",
    data() {
        return {
            userdata:'',
            visibilities: ['private', 'community', 'world'],
            timeslicedata:'',
            message:'',
        }
    },

    props: {
        mytimeslices:'',
        user:'',
    },
    mounted() {
        this.userdata = JSON.parse(this.user);
        this.timeslicedata = JSON.parse(this.mytimeslices);
        console.error("ShowofforumVisibility Switcher invoked")
        EventBus.$on('showofForumVisibilitySwitcher', (data) => {
            console.error("showofForumVisibilitySwitcher Video modal invoked");
            $('div#tsdisplay-switcher-modal').modal('show');
        });

    },
    methods: {
        getDateFormat(aDate) {
            return '@ '+ moment(aDate).format('DD MMM YY');
        },
        recordVisibilityChange(tsliceID, visibility) {
            console.log("Tslice: " + tsliceID +", visib: " + visibility);
        },
        getTimeSlice(id) {
            var tS = '';
            [...this.timeslicedata].forEach((tx)=>{
                if(tx.id == id) tS = tx;
            });
            return tS;
        },
        saveVisiblityChange(tsliceID, visibility) {
            this.message = '';
            // console.log("Tslice: " + tsliceID );
            var tS = this.getTimeSlice(tsliceID);
            console.log("vis:" + tS.visibility);
            axios.post(`/showofforum/timeslice/visibility/`+tsliceID, {visibility:tS.visibility})
            .then(response => {
            if (!response.data.updated) {
                console.error("Unable to update. Please try later");
                this.updateToast("Unable to update. Please try later", 4000, 'error');
            } else {
               console.log(response);
               this.message=response.data.message;
            //    this.refreshPage();
            this.updateToast(response.data.message, 4000, 'success');
            }
            })
            .catch(err => {
                console.error(err);
            });
        },

        getHeading(){
            return 'Share Your Time-Slices: Inspire your World';
        },
        cancel() {
            this.message = '';
            $('div#tsdisplay-switcher-modal').modal('hide');
        },
        getDateFormat(aDate) {
            return moment(aDate).format('DD MMM YY');
        },
        viewFull(timeSliceID) {
            // console.error(timeSliceID);
            var tS = '';
            [...this.timeslicesdata].map((aTS)=>{
                if(aTS.id == timeSliceID) tS = aTS;
            });
            // console.log(tS);
            EventBus.$emit('showFullTS', {timeslicedata:tS});
        },
        strip(html){
            let doc = new DOMParser().parseFromString(html, 'text/html');
            return doc.body.textContent || "";
        },
        getSubset(text, size) {
            var theInput = this.strip(text);
            return theInput.substring(0,  size) + '...';
        },
        getFilePath(filePath) {
            return "/storage/"+ filePath;
        },
  updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },



    }
}
</script>

<style scoped>
.content-box-gray .content {
    overflow:    ;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
    background:#5fa3ca;
    font-size:.75em;
    /* font-weight:bold; */
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}
.radiolabel{
    /* display:inline-block; */
    font-size: .5em;
    font-weight: 400 !important;
}
.savelabel{
    /* display:inline-block; */
    font-size: .5em;
    font-weight: 600 !important;
    text-align:center;
}

</style>
